// Browsers lock a wheel/trackpad gesture to the element it started on, so moving the
// cursor from the gallery to the info panel mid-scroll kept scrolling the gallery.
// Here every wheel tick goes to whichever column is under the cursor instead.
;(() => {
  const page = document.scrollingElement || document.documentElement
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)")
  const LINE_HEIGHT = 40
  // Wheel ticks closer together than this are treated as the same gesture.
  const GESTURE_GAP = 200

  const position = (scroller) => scroller.wheelTarget ?? scroller.scrollTop

  const canScroll = (scroller, delta) =>
    delta > 0
      ? position(scroller) < scroller.scrollHeight - scroller.clientHeight - 1
      : position(scroller) > 0

  const hasNestedScroller = (element, stopAt, delta) => {
    for (let el = element; el && !stopAt.includes(el); el = el.parentElement) {
      if (/auto|scroll/.test(getComputedStyle(el).overflowY) && canScroll(el, delta)) {
        return true
      }
    }
    return false
  }

  const scrollSmoothly = (scroller, delta) => {
    // Trackpads already send small, smooth steps; only ease mouse wheel notches.
    if (reduceMotion.matches || (!scroller.wheelFrame && Math.abs(delta) < 40)) {
      scroller.scrollTop += delta
      return
    }

    const max = scroller.scrollHeight - scroller.clientHeight
    scroller.wheelTarget = Math.min(max, Math.max(0, position(scroller) + delta))
    if (scroller.wheelFrame) return

    const step = () => {
      const distance = scroller.wheelTarget - scroller.scrollTop
      const before = scroller.scrollTop
      const done = Math.abs(distance) <= 1

      scroller.scrollTop = done
        ? scroller.wheelTarget
        : before + Math.sign(distance) * Math.max(1, Math.abs(distance) * 0.3)

      if (done || scroller.scrollTop === before) {
        scroller.wheelTarget = scroller.wheelFrame = null
        return
      }
      scroller.wheelFrame = requestAnimationFrame(step)
    }
    step()
  }

  for (const panel of document.querySelectorAll(".product__info-container--sticky")) {
    const grid = panel.closest(".product")
    if (!grid || grid.closest("quick-add-modal") || grid.dataset.wheelRouting) continue
    grid.dataset.wheelRouting = "true"

    let lastPanelWheel = -Infinity

    grid.addEventListener(
      "wheel",
      (event) => {
        if (!event.cancelable || event.defaultPrevented || event.ctrlKey) return
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return
        // Only take over while the panel is its own scroller (tablet up, taller than the viewport).
        if (
          getComputedStyle(panel).overflowY !== "auto" ||
          panel.scrollHeight <= panel.clientHeight + 1
        ) {
          return
        }

        const hovered = document.elementFromPoint(event.clientX, event.clientY)
        if (!hovered || !grid.contains(hovered)) return

        const delta =
          event.deltaY *
          (event.deltaMode === 1 ? LINE_HEIGHT : event.deltaMode === 2 ? window.innerHeight : 1)
        if (hasNestedScroller(hovered, [panel, grid], delta)) return

        event.preventDefault()

        if (panel.contains(hovered)) {
          const panelGesture = event.timeStamp - lastPanelWheel < GESTURE_GAP
          if (canScroll(panel, delta) || panelGesture) {
            // Once the panel hits its end, let the gesture stop there instead of
            // spilling into the page; a new gesture will scroll the page.
            lastPanelWheel = event.timeStamp
            if (canScroll(panel, delta)) scrollSmoothly(panel, delta)
            return
          }
        }

        scrollSmoothly(page, delta)
      },
      { passive: false },
    )
  }
})()
